import script from "./MenuBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuBanner.vue?vue&type=script&setup=true&lang=js"

import "./MenuBanner.vue?vue&type=style&index=0&id=0037f7f2&lang=scss"

const __exports__ = script;

export default __exports__